import { Chips, Separator, Switch } from 'platform/components';
import { HStack, VStack } from 'platform/foundation-tw';
import { isBoolean, isString } from 'ramda-adjunct';
import { suffixTestId } from 'shared/web';
import { useFilterOnChipsChange } from '../../hooks/useFilterOnChipsChange';
import type { EagFilterProps } from '../../types/EagFilterProps';
export type SwitchFilterProps = EagFilterProps & {
  quickFilters?: Array<{
    value: string;
    label: string;
  }>;
};
const FILTER_VALUE_KEY = 'value';
export function SwitchFilter(props: SwitchFilterProps) {
  const model = props.value[FILTER_VALUE_KEY] as string | boolean | null;
  const setValue = (newModel: string | boolean | null) => {
    props.onChange({
      [FILTER_VALUE_KEY]: newModel ?? null
    });
  };
  const {
    onChipsChange
  } = useFilterOnChipsChange({
    setFilterValue: setValue,
    defaultValue: false
  });
  const onChange = (value: boolean) => {
    setValue(value);
  };
  const isQuickFilterValue = isString(model) ? [model] : null;
  const isValue = isBoolean(model) ? model : false;
  return <VStack>
      {props.quickFilters && props.quickFilters.length > 0 && <>
          <HStack>
            <Chips isDisabled={props.isDisabled} value={isQuickFilterValue} options={props.quickFilters} onChange={onChipsChange} isMultiple={false} data-testid={suffixTestId('switch-filter-quickFilters', props)} isDeselectable />
          </HStack>
          <Separator />
        </>}
      <Switch isDisabled={props.isDisabled} value={isValue} onChange={onChange} data-testid={suffixTestId('switch-filter', props)} />
    </VStack>;
}